const tabsConfig = [
	{ name: 'software', displayText: 'software_change_summary' },
	{ name: 'pairing', displayText: 'pairing_history' },
	{ name: 'connection', displayText: 'connection_history' },
	{ name: 'ErrorRecall', displayText: 'error_last_12_months' },
];

export default tabsConfig;
